import { authProcess } from './auth-process'
import { put } from './inner-store'
import { iAuthApi, iAuthConfig } from './types'

export type iAuth = (param: iAuthConfig) => Promise<iAuthApi>

const init: iAuth = async ({ validateRequest }) => {
  put('validateRequest', validateRequest)

  return {
    authProcess,
  }
}

export { init }
